import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NotRestrictedPipe } from "./not-restricted.pipe";
import { RestrictToDirective } from "./restrict-to.directive";
import { RestrictedPipe } from "./restricted.pipe";

@NgModule({
  declarations: [
    RestrictToDirective,
    NotRestrictedPipe,
    RestrictedPipe
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RestrictToDirective,
    NotRestrictedPipe,
    RestrictedPipe
  ]
})
export class RestrictionsModule {

}